import {  Delete, Edit, FilterList, RemoveRedEye } from "@mui/icons-material";
import BlindsClosedIcon from "@mui/icons-material/BlindsClosed";
import {
  Grid,
  IconButton,
  Skeleton,
  Stack,
  TableCell,
  Tooltip,
  Typography
} from "@mui/material";
import EmptyContent from "components/EmptyContent";
import List from "components/UI/List";
import { useAlert } from "contexts/alertContext";
import { Feature } from "models/api";
import {
  IWorkshop,
  IWorkshopCancellationReasons,
  IWorkshopInput,
  WorkshopStatus,
} from "models/workshop";
import React, { useEffect, useRef, useState } from "react";
import { QueryClient, useMutation } from "react-query";

import BlockIcon from "@mui/icons-material/Block";
import { getCompanyProficiencyLevels } from "framework/companyProficiencyLevel";
import { getTrainers } from "framework/trainer";
import {
  WorkshopCells,
  WorkshopCellsExport,
  addWorkshop,
  deleteWorkshop,
  editWorkshop,
  formatExcellValue,
  getCancellationReasons,
  getVendorAssessmentWorkshops,
  getWorkshops
} from "framework/workshops";
import {  getPermission, getUserData } from "helpers";
import { handleError } from "helpers/utils";
import useFetchSection from "hooks/useFetchSection";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { UserType } from "types/auth";
import DeleteWorkshop from "./partials/DeleteWorkshop/DeleteWorkshop";
import EditWorkshop from "./partials/EditWorkshop/EditWorkshop";
import FilterListModal from "./partials/FilterListModal";
import dayjs from "dayjs";
import { IWorkshopEvaluation } from "models/workshopEvaluation";
import { ICompany } from "models/company";

interface Props {
  feature: Feature;
}

interface _Filter {
  vendors?: any;
  venues?: any;
  modalities?: any;
  trainers?: any;
  topics?: any;
  companies?: any;
  cities?: any;
  countries?: any;
  competecnies?: any;
  profLevel?: any;
  cancellationReasons?: IWorkshopCancellationReasons[];
  languages?: any
}

const formatToday = () => dayjs().format("DD/MM/YYYY");

const VendorAssessmentWorkshops: React.FC<Props> = ({ feature }) => {
  const { t, i18n } = useTranslation();
  const [loading2, setLoading2] = useState<boolean>(false);
  const [FilterWorkshops, setFilterWorkshops] = useState<IWorkshop[]>(
    [] as IWorkshop[]
  );
  const [filters, setFilters] = useState<_Filter>({});
  const [openEdit, setOpenEdit] = useState<boolean>(false);
  const [openDelete, setOpenDelete] = useState<boolean>(false);

  const [selectedWorkshop, setSelectedWorkshop] = useState<IWorkshop>(
    {} as IWorkshop
  );
  const filtersRef = useRef<any>(null);
  const userData = getUserData();
  const { colors, user, roleName } = userData;
  const userType = user.userType;
  const [inputObj, setInputObj] = useState<IWorkshopInput>(
    {} as IWorkshopInput
  );
    const urlParams = useParams();
    let id: string = urlParams[`${feature.singleName}Id`] as string;

  const [workshopEvaluations, setWorkshopEvaluations] = useState<IWorkshopEvaluation[]>(
    [] as IWorkshopEvaluation[]
  );

  const { setAlert } = useAlert();

  const now = new Date();
  const year = now.getFullYear();


  const [openFilter, setOpenFilter] = useState(false);
  const [filterState, setFilterState] = useState({
    department: "",
    provider: "",
    vendors: "",
    venues: "",
    topic: "",
    modalities: "",
    countries: "",
    cities: "",
    languages: "",
    trainers: "",
    startDate: new Date(year, 0, 1),
    endDate: new Date(year, 11, 31),
  });

  let convertToUTCDate = function (inputDate: Date) {
    let localDate = new Date(inputDate);
    localDate.setUTCFullYear(localDate.getFullYear());
    localDate.setUTCMonth(localDate.getMonth());
    localDate.setUTCDate(localDate.getDate());
    localDate.setUTCHours(0, 0, 0, 0);
    return localDate;
  }

  // eslint-disable-next-line
  const queryClient = new QueryClient();

  const addWorkshopsMutation = useMutation({
    mutationFn: (createInput: IWorkshopInput) => {
      return addWorkshop({
        ...createInput,
        capacity: +createInput.capacity,
        status: WorkshopStatus.ACTIVE,
      });
    },
  });

  const editWorkshopsMutation = useMutation({
    mutationFn: (data: { createInput: IWorkshopInput; id: string }) => {
      return editWorkshop(data.createInput, selectedWorkshop.workshopId);
    },
  });

  const deleteWorkshopsMutation = useMutation({
    mutationFn: (code: string) => {
      return deleteWorkshop(code);
    },
  });

  const {
    loading,
    data: Workshops,
    permission,
    revalidate,
  } = useFetchSection({
    fetchData: () => getVendorAssessmentWorkshops(`?AssessmentDefinitionId=${id}`), //?AssessmentDefinitionId=63a1f3a7-bdf1-4ca7-b4eb-ee78aef3da9f
    fetchPermission: () => getPermission(6),
    section: "Workshops",
    onSuccess: (data) => {
      setFilterWorkshops(data)
    },
    processResponse: (data) =>
      data.map((item) => {
        return { ...item, requiresInvitationStr: item.requiresInvitation ? 'Yes' : 'No', };
      }),
  });

  // get filters
  const fetchFilters = async () => {
    try {
      const [
        trainersResponse,
        profLevelResponse,
        cancellationReasonsResponse,
        filtersResponse,
      ] = await Promise.all([

        queryClient.fetchQuery("get Trainers", () => getTrainers()),
        queryClient.fetchQuery("get Prof level", () =>
          getCompanyProficiencyLevels()
        ),
        queryClient.fetchQuery("get Cancellation Reasons", () =>
          getCancellationReasons()
        ),
        queryClient.fetchQuery("getWorkshopFilters", () => getWorkshops(`/filters`))
      ]);

      setFilters({
        trainers: trainersResponse,
        profLevel: profLevelResponse,
        cancellationReasons: cancellationReasonsResponse,
        ...filtersResponse
      });
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
    }
  };


  useEffect(() => {
    fetchFilters();
    // fetchWorkshopEvaluations();
    // fetchCompanyTimeZone();
    // eslint-disable-next-line
  }, []);

  if (loading)
    return (
      <Stack spacing={2} p={2}>
        {Array.from({ length: 10 }).map((_, i) => (
          <Skeleton variant="rectangular" key={i} width="100%" height={30} />
        ))}
      </Stack>
    );

  const handleChange = (name: string, value: any) => {
    if (name === "competencies") {
      let competencies = value
        .map((competency: any) => competency.value)
        .join(";");
      setInputObj((prev) => ({
        ...prev,
        [name]: competencies,
      }));
    }

    if (name.includes('Time')) {

      const date = dayjs(value);


      const time = `${String(date.hour()).padStart(2, '0')}:${String(date.minute()).padStart(2, '0')}:00`;

      setInputObj((prev) => ({
        ...prev,
        [name]: time,
      }));
    }

    else if (name === "languages") {
      let languages = value
        .map((language: any) => ({ Id: language.value }))

      setInputObj((prev) => ({
        ...prev,
        [name]: languages,
      }));
    }
    else if (name === "requires_invitation") {
      setInputObj((prev) => ({
        ...prev,
        [name]: value || false,
      }));
    }

    else {
      setInputObj((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleOpenEdit = (Workshop: IWorkshop) => {
    setSelectedWorkshop(Workshop);
    setInputObj({modality: Workshop.modality,islocked:Workshop.isLocked} as IWorkshopInput)
    setOpenEdit(true);
  };
  const handleCloseEdit = () => {
    setOpenEdit(false);
    setSelectedWorkshop({} as IWorkshop);
    setInputObj({} as IWorkshopInput)
  };

  const handleOpenDelete = (Workshop: IWorkshop) => {
    setSelectedWorkshop(Workshop);
    setOpenDelete(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setSelectedWorkshop({} as IWorkshop);
    setInputObj({} as IWorkshopInput)
  };

  const getBodyCells = (row: IWorkshop) => {
    let cells = Object.keys(row).map((key: string, i: number) => {
      if (key === "companyName")
        return {
          id: "companyName",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">
                {i18n.language === "en" ? row.companyName : row.companyNameAr}
              </Typography>
            </TableCell>
          ),
        };
      if (key === "vendorName")
        return {
          id: "vendorName",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">
                {i18n.language === "en" ? row.vendorName : row.vendorNameAr}
              </Typography>
            </TableCell>
          ),
        };

      if (key === "venueName")
        return {
          id: "venueName",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">
                {i18n.language === "en" ? row.venueName : row.venueNameAr}
              </Typography>
            </TableCell>
          ),
        };
      if (key === "trainer")
        return {
          id: "trainer",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">
                {i18n.language === "en" ? row.trainer : row.trainerNameAr}
              </Typography>
            </TableCell>
          ),
        };

      if (key === "topicName")
        return {
          id: "topicName",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">
                {i18n.language === "en" ? row.topicName : row.topicNameAr}
              </Typography>
            </TableCell>
          ),
        };
      if (key === "roomNumber") return undefined;
      if (key === "languages")
        return {
          id: "languages",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.languages.map(a => a.name).join(',')}</Typography>
            </TableCell>
          ),
        };

      if (key === "link")
        return {
          id: "link",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.link}</Typography>
            </TableCell>
          ),
        };

      if (key === "companies")
        return {
          id: "companies",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row!?.companies!?.map(a => filters.companies.find((item: ICompany) => item?.id === a)?.name).join(',')}</Typography>
            </TableCell>
          ),
        };

      if (key === "fromDate")
        return {
          id: "fromDate",
          element: (
            <TableCell align={"left"} key={i}>
              {row.fromDate && (
                <Typography variant="body2">
                  {row.fromDateDisplay}
                  {/* {new Date(row.fromDate).toLocaleDateString()} */}
                </Typography>
              )}
            </TableCell>
          ),
        };
      if (key === "toDate")
        return {
          id: "toDate",
          element: (
            <TableCell align={"left"} key={i}>
              {row.toDate && (
                <Typography variant="body2">
                  {row.toDateDisplay}
                  {/* {new Date(row.toDate).toLocaleDateString()} */}
                </Typography>
              )}
            </TableCell>
          ),
        };

      if (key === "fromTime") {
        const from = row.fromTimeDisplay || row.fromTime || "";
        const to = row.toTimeDisplay || row.toTime || "";
        const range = [from, to].filter(Boolean).join(" - " );

        return {
          id: "fromTime",
          element: (
            <TableCell align={"left"} key={i}>
              {range && (
                <Typography variant="body2">
                  {range}
                </Typography>
              )}
            </TableCell>
          ),
        };
      }
      if (key === "toTime") return undefined;
      if (key === "averagePostScore")
        return {
          id: "averagePostScore",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">
                {row.averagePostScore.toString()}
              </Typography>
            </TableCell>
          ),
        };

      if (key === "requiresInvitation")
        return {
          id: "requiresInvitation",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">
                {row.requiresInvitationStr}
              </Typography>
            </TableCell>
          ),
        };
      if (key === "prerequisite")
        return {
          id: "prerequisite",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">
                {row.prerequisite}
              </Typography>
            </TableCell>
          ),
        };
      if (key === "attendanceFrequency")
        return {
          id: "attendanceFrequency",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">
                {row.attendanceFrequency}
              </Typography>
            </TableCell>
          ),
        };

      if (key === "workshopId")
        return {
          id: "actions",
          element: (
            <TableCell align={"left"} key={i}>
              <Stack
                direction={"row"}
                alignContent={"center"}
                spacing={1}
                justifyContent={i18n.language === "en" ? "start" : "end"}
              >
                {permission?.hasModifyPermission && (
                  <Tooltip title={t("T_edit")}>
                    <IconButton
                      size={"small"}
                      color={"primary"}
                      onClick={() => handleOpenEdit(row)}
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                )}

                {userType !== UserType.VENDOR_USER &&
                  permission?.hasDeletePermission && (
                    <Tooltip title={t("T_delete")}>
                      <IconButton
                        size={"small"}
                        sx={{
                          color: colors.deleteIconColor
                            ? colors.deleteIconColor
                            : "red",
                          "&:hover": { color: colors?.deleteIconHoverColor },
                        }}
                        onClick={() => handleOpenDelete(row)}
                      >
                        <Delete />
                      </IconButton>
                    </Tooltip>
                  )}

                <Tooltip title={t("T_details")}>
                  <Link to={`${row.workshopId}`}>
                    <IconButton size={"small"} color={"info"}>
                      <RemoveRedEye
                        sx={{
                          color: colors.viewIconColor
                            ? colors.viewIconColor
                            : "#0288d1",
                          "&:hover": { color: colors?.viewIconHoverColor },
                        }}
                      />
                    </IconButton>
                  </Link>
                </Tooltip>
              </Stack>
            </TableCell>
          ),
        };
      else return <></>;
    });

    return cells;
  };


  const handleFilterChange = (key: string, value: string) => {
    setFilterState((prev) => ({ ...prev, [key]: value }));
    makeRequest({ ...filterState, [key]: value });
  };

  const makeRequest = (filterData: typeof filterState) => {
    let filtered = Workshops!;
    const { vendors, venues, provider, topic, modalities,trainers, countries, cities, languages } = filterData;

    if (provider) filtered = filtered.filter((w) => w.companyId === provider);
    if (topic) filtered = filtered.filter((w) => w.topicId === topic);
    if (modalities) filtered = filtered.filter((w) => w.modality === +modalities);
    if (venues) filtered = filtered.filter((w) => w.venueId === venues);
    if (trainers) filtered = filtered.filter((w) => w.trainerId === trainers);
    if (vendors) filtered = filtered.filter((w) => w.vendorId === vendors);
    if (countries) filtered = filtered.filter((w) => w.countryId === countries);
    if (cities) filtered = filtered.filter((w) => w.cityId === cities);
    if (languages) filtered = filtered.filter((w) => w.languages.find((l) => l.id === languages));
    if (filterData.startDate) {
      filtered = filtered.filter((w) => {
        const fromDate = new Date(w.fromDate);
        //fromDate.setDate(fromDate.getDate() + 1);
        return fromDate >= filterData.startDate;
      });
    }

    if (filterData.endDate) {
      filtered = filtered.filter((w) => {
        const toDate = new Date(w.toDate);
        // toDate.setDate(toDate.getDate() - 1);
        return toDate <= filterData.endDate;
      });
    }
    setFilterWorkshops(filtered);
  };


  const resetFilters = () => {
    if (filtersRef.current) {
      filtersRef.current.resetFilters(); // Call the reset function from Filters component
    }
    makeRequest({
      department: "",
      provider: "",
      vendors: "",
      venues: "",
      topic: "",
      modalities: "",
      countries: "",
      trainers: "",
      cities: "",
      languages: "",
      startDate: new Date(year, 0, 1),
      endDate: new Date(year, 11, 31),
    });
    setFilterState({
      department: "",
      provider: "",
      vendors: "",
      venues: "",
      topic: "",
      modalities: "",
      countries: "",
      trainers: "",
      cities: "",
      languages: "",
      startDate: new Date(year, 0, 1),
      endDate: new Date(year, 11, 31),
    })
  };

  const handleEdit = async (data: any[]) => {


    if ((inputObj.toDate || selectedWorkshop.toDate) < (inputObj.fromDate || selectedWorkshop.fromDate)) {
      return setAlert({
        open: true,
        message: "The 'To Date' must not be before the 'From Date'.",
        type: "error",
      });
    }


    if ((inputObj.evaluationValidTo || selectedWorkshop.evaluationValidTo) < (inputObj.evaluationValidFrom || selectedWorkshop.evaluationValidTo)) {
      return setAlert({
        open: true,
        message: "The 'Evaluation To Date' must not be before the 'Evaluation From Date'.",
        type: "error",
      });
    }

    try {
      setLoading2(true);
      let createInput: IWorkshopInput = {
        vendorId: inputObj.vendorId || selectedWorkshop.vendorId,
        venueId: inputObj.venueId || selectedWorkshop.venueId,
        trainerId: inputObj.trainerId || selectedWorkshop.trainerId,
        topicId: inputObj.topicId || selectedWorkshop.topicId,
        status: +inputObj.status || +selectedWorkshop.status,
        roomNumber: inputObj.roomNumber,
        capacity: inputObj.capacity || selectedWorkshop.capacity,
        fromDate: inputObj.fromDate || selectedWorkshop.fromDate,
        toDate: inputObj.toDate || selectedWorkshop.toDate,
        companies: inputObj.companies || selectedWorkshop.companies,
        fromTime: inputObj.fromTime || selectedWorkshop.fromTime,
        toTime: inputObj.toTime || selectedWorkshop.toTime,
        evaluationValidFrom: inputObj.evaluationValidFrom || selectedWorkshop.evaluationValidFrom,
        evaluationValidTo: inputObj.evaluationValidTo || selectedWorkshop.evaluationValidTo,
        workshopEvaluationId: inputObj.workshopEvaluationId || selectedWorkshop.workshopEvaluationId,
        link: inputObj.link || selectedWorkshop.link,
        attendanceFrequency: inputObj.attendanceFrequency || selectedWorkshop.attendanceFrequency,
        modality: +inputObj.modality || +selectedWorkshop.modality,
        coHost: inputObj.coHost || selectedWorkshop.coHost,
        prerequisite: inputObj.prerequisite ?? selectedWorkshop.prerequisite,
        requires_invitation: inputObj.requires_invitation ?? (selectedWorkshop.requiresInvitation || false),
        languages: inputObj.languages || selectedWorkshop.languages,
        topicCompetencies: data,
        islocked:inputObj.islocked ,
      };
      await editWorkshopsMutation.mutateAsync({
        createInput,
        id: selectedWorkshop.workshopId,
      });
      setAlert({
        open: true,
        message: "Workshop updated successfully",
        type: "success",
      });
      revalidate();
      handleCloseEdit();
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading2(true);
      await deleteWorkshopsMutation.mutateAsync(selectedWorkshop.workshopId);
      setAlert({
        open: true,
        message: "Workshop deleted successfully",
        type: "success",
      });
      revalidate();
      handleCloseDelete();
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };


  return (
    <>
      <Stack spacing={2} p={2}>
        <Grid
          container
          justifyContent={"space-between"}
          alignItems="center"
          sx={{ mb: 4 }}
        >
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            spacing={1}
            width={"100%"}
            marginBottom={5}
          >
            <Typography
              variant="h3"
              color={colors?.labelColor ? colors?.labelColor : "header.primary"}
            >
              {t(feature.name)}
            </Typography>
            <Stack direction={"row"} spacing={1}>
              {/* {userType !== UserType.VENDOR_USER &&
                permission?.hasModifyPermission &&
                filters && (
                  <Tooltip title="Add Workshop">
                    <IconButton
                      sx={{
                        color: colors.addUpdateIconColor
                          ? colors.addUpdateIconColor
                          : "red",
                        "&:hover": { color: colors?.addUpdateIconHoverColor },
                        height: 40,
                        width: 40,
                        transition: "0.5s",
                      }}
                      onClick={handleOpenAdd}
                    >
                      <Add />
                    </IconButton>
                  </Tooltip>
                )} */}
              <Tooltip title={t('T_filter_workshops')}>
                <IconButton onClick={() => setOpenFilter(true)}>
                  <FilterList />
                </IconButton>
              </Tooltip>
            </Stack>
          </Stack>
        </Grid>

        {permission?.hasReadPermission! && FilterWorkshops.length > 0 && (
          <List
            headCells={WorkshopCells}
            data={FilterWorkshops}
            getBodyCells={getBodyCells}
            feature={feature}
            canEdit={false}
            formatExcelValue={formatExcellValue}
            exportHeaders={WorkshopCellsExport}
          />
        )}
        {(!FilterWorkshops || FilterWorkshops.length === 0) &&
          permission?.hasReadPermission! && (
            <EmptyContent
              icon={<BlindsClosedIcon sx={{ fontSize: "3.5rem " }} />}
              header={t("T_no_workshop_header")}
              message={t("T_no_workshop_message")}
            />
          )}

        {!permission?.hasReadPermission && (
          <EmptyContent
            icon={<BlockIcon sx={{ fontSize: "3.5rem " }} />}
            header={t("T_no_permissions")}
            message={t("T_no_permissions_message")}
          />
        )}
      </Stack>

      {openEdit && filters && (
        <EditWorkshop
          inputObj={inputObj}
          open={openEdit}
          loading={loading2}
          workshopEvaluations={workshopEvaluations}
          vendors={filters.vendors}
          venues={filters.venues}
          countries={filters.countries}
          cities={filters.cities}
          trainers={filters.trainers}
          topics={filters.topics}
          profLevel={filters.profLevel}
          modalities={filters.modalities}
          competencies={filters.competecnies}
          workshop={selectedWorkshop}
          languages={filters.languages}
          onClose={handleCloseEdit}
          onSubmit={handleEdit}
          onChanges={handleChange}
        />
      )}
      {openDelete && (
        <DeleteWorkshop
          open={openDelete}
          loading={loading2}
          onClose={handleCloseDelete}
          onSubmit={handleDelete}
        />
      )}

      {openFilter && (
        <FilterListModal
          open={openFilter}
          filters={filters}
          {...filterState}
          onClose={() => setOpenFilter(false)}
          onReset={resetFilters}
          onChangeCities={(e: any) => handleFilterChange("cities", e)}
          onChangeCountries={(e: any) => handleFilterChange("countries", e)}
          onChangeLanguages={(e: any) => handleFilterChange("languages", e)}
          onChangeModalities={(e: any) => handleFilterChange("modalities", e)}
          onChangeTopic={(e: any) => handleFilterChange("topic", e)}
          onChangeTrainer={(e: any) => handleFilterChange("trainers", e)}
          onChangeVenues={(e: any) => handleFilterChange("venues", e)}
          onChangeVendor={(e: any) => handleFilterChange("vendors", e)}
          onChangeStartDate={(e: any) => handleFilterChange("startDate", e)}
          onChangeEndDate={(e: any) => handleFilterChange("endDate", e)}
        />
      )}
    </>
  );
};

export default VendorAssessmentWorkshops;
